import { render } from "./ProductOrdersReport.vue?vue&type=template&id=75e69457"
import script from "./ProductOrdersReport.vue?vue&type=script&lang=js"
export * from "./ProductOrdersReport.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/mwon.net/gugar.mwon.net/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__